export default function ChannelNotifications(Restangular) {
  'ngInject';

  Restangular.extendModel('channels/notifications', (notification) => {
    let usePostfix = false;
    notification.text = '';

    if (notification.actor) {
      Restangular.restangularizeElement(null, notification.actor, 'users');
    }

    if (notification.article?.user) {
      Restangular.restangularizeElement(null, notification.article.user, 'users');
    }

    const getTextByType = {
      comment_like: () => `${notification.actor.name} liked a comment on`,
      like: () => `${notification.actor.name} liked`,
      comment: () => `${notification.actor.name} commented on`,
      article: () => `${notification.actor.name} created a new post`,
      mention: () => `${notification.actor.name} mentioned you in a post`,
    };

    if (notification.type in getTextByType) {
      notification.text = getTextByType[notification.type]();
    }

    const isPostfix = {
      comment_like: true,
      like: true,
      comment: true,
      article: false,
      mention: false,
    };

    if (notification.type in isPostfix) {
      usePostfix = isPostfix[notification.type];
    }

    if (usePostfix) {
      if (!notification.article.user) {
        notification.text += ' a post';
      } else if (notification.article.user.isMe) {
        notification.text += ' your post';
      } else {
        notification.text += ` a post by ${notification.article.user.name}`;
      }
    }

    if (notification.text.length) {
      notification.text += ` in ${notification.article.channel.name}`;
    }

    return notification;
  });

  return Restangular.service('channels/notifications');
}
